import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const pagesIndex = lazyWithRetry(() => import("./routes/pages"));
const pageNew = lazyWithRetry(() => import("./routes/pages/new"));
const pageEdit = lazyWithRetry(() => import("./routes/pages/[id]/edit"));
const menusIndex = lazyWithRetry(() => import("./routes/menus"));
const cmsImportExport = lazyWithRetry(() => import("./routes/import-export"));
const blocksIndex = lazyWithRetry(() => import("./routes/blocks"));
const mediaIndex = lazyWithRetry(() => import("./routes/media"));
const redirectsIndex = lazyWithRetry(() => import("./routes/redirects"));

const pagesIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/pages",
  component: () =>
    renderProtectedRoute(pagesIndex, { requirePerms: ["cms:read"] }),
});

const pageNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/pages/new",
  component: () =>
    renderProtectedRoute(pageNew, { requirePerms: ["cms:write"] }),
});

const pageEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/pages/$id/edit",
  component: () =>
    renderProtectedRoute(pageEdit, { requirePerms: ["cms:read"] }),
});

const menusIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/menus",
  component: () =>
    renderProtectedRoute(menusIndex, { requirePerms: ["cms:read"] }),
});

const cmsImportExportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/import-export",
  component: () =>
    renderProtectedRoute(cmsImportExport, { requirePerms: ["cms:read"] }),
});

const blocksIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/blocks",
  component: () =>
    renderProtectedRoute(blocksIndex, { requirePerms: ["cms:read"] }),
});

const mediaIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/media",
  component: () =>
    renderProtectedRoute(mediaIndex, { requirePerms: ["cms:read"] }),
});

const redirectsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cms/redirects",
  component: () =>
    renderProtectedRoute(redirectsIndex, { requirePerms: ["cms:read"] }),
});

export const cmsRouteTree = [
  pagesIndexRoute,
  pageNewRoute,
  pageEditRoute,
  menusIndexRoute,
  cmsImportExportRoute,
  blocksIndexRoute,
  mediaIndexRoute,
  redirectsIndexRoute,
];
